import { api } from "~/api";
import { computed, reactive, defineComponent, ref } from "vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { useRouter } from "vue-router";
import { store } from "../store/TaikyoStore";
import { myPageStore } from "~/store/MyPageStore";
import { commonStore } from "~/store/CommonStore";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { PageID } from "~/extensions/utils/DefineTypes";
const log = Log.create("TaikyoPrecautions");
const privacyConsentErrorMessage = "選択してください。";
const isNotification = ref(false);
export default defineComponent({
    components: {
        BreadcrumbList
    },
    name: "TaikyoPrecautionsPage",
    beforeRouteEnter(to, from, next) {
        const fromScreen = from.name;
        const relatedScreens = ["taikyo-flow-guide", "taikyo-entry", "taikyo-entry-check"];
        isNotification.value = false;
        if (relatedScreens.includes(fromScreen)) {
            next();
            return;
        }
        const relatedNotificationScreens = ["taikyo-notification-flow-guide", "taikyo-notification-entry", "taikyo-notification-entry-check"];
        if (relatedNotificationScreens.includes(fromScreen)) {
            isNotification.value = true;
            next();
            return;
        }
        next({ name: "taikyo" });
    },
    async setup() {
        const html = ref("");
        const privacyConsent = ref(false);
        const isChangeOrSubmitted = ref(false);
        const router = useRouter();
        // 画面名取得
        const pageName = commonStore.pageName(PageID.taikyoPrecaution);
        const tenants = myPageStore.personal.nyukyokeiyakuList.filter(x => store.notFoundNyukyoList.includes(x.orgNyukyokeiyakuNo));
        const show = computed(() => store.showNotFoundNyukyoDialog);
        const valid = reactive({
            privacyConsent: {
                error: computed(() => isChangeOrSubmitted.value && !privacyConsent.value),
                message: computed(() => (isChangeOrSubmitted.value && !privacyConsent.value ? privacyConsentErrorMessage : ""))
            }
        });
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        try {
            html.value = await api.taikyo.loadPrecautionsText();
        }
        catch (ex) {
            log.error("setup", ex);
            MsgBox.error(ex.message);
        }
        const saveConsentAndNavigate = () => {
            isChangeOrSubmitted.value = true;
            if (valid.privacyConsent.error) {
                return;
            }
            // ストアに保持
            store.setPrivacyConsent(privacyConsent.value);
            if (isNotification.value) {
                router.push({ name: "taikyo-notification-entry" });
            }
            else {
                router.push({ name: "taikyo-entry" });
            }
        };
        const close = () => {
            store.showNotFoundNyukyoDialog = false;
        };
        return {
            html,
            valid,
            privacyConsent,
            saveConsentAndNavigate,
            isNotification,
            isMultipleKeiyaku,
            isChangeOrSubmitted,
            pageName,
            PageID,
            tenants,
            show,
            store
        };
    }
});
